import { Trash } from "@phosphor-icons/react";

export function LineEditor({ products, lines, onChange }) {
  const set = (i, k, v) => {
    const next = [...lines];
    next[i] = { ...next[i], [k]: k === "sku" ? v : Number(v) || 0 };
    onChange(next);
  };
  const remove = (i) => onChange(lines.filter((_, idx) => idx !== i));
  return (
    <div className="grid grid-cols-[1fr_100px_120px_36px] gap-px bg-zinc-200 border border-zinc-300">
      <div className="bg-zinc-50 label-sm text-zinc-500 px-3 py-2">Product</div>
      <div className="bg-zinc-50 label-sm text-zinc-500 px-3 py-2 text-right">Qty</div>
      <div className="bg-zinc-50 label-sm text-zinc-500 px-3 py-2 text-right">Unit Price</div>
      <div className="bg-zinc-50" />
      {lines.map((l, i) => (
        <div key={l._id} className="contents">
          <select value={l.sku} onChange={(e) => set(i, "sku", e.target.value)} required data-testid={`line-${i}-sku`} className="bg-white px-3 py-2 text-sm outline-none">
            <option value="">— select —</option>
            {products.map((p) => <option key={p.id} value={p.sku}>{`${p.sku} · ${p.name} (stock ${p.stock})`}</option>)}
          </select>
          <input type="number" min="1" step="1" value={l.quantity} onChange={(e) => set(i, "quantity", e.target.value)} required data-testid={`line-${i}-qty`} className={`bg-white px-3 py-2 text-sm text-right tnum outline-none ${l.quantity <= 0 ? "text-[#D0021B]" : ""}`} />
          <input type="number" step="0.01" min="0" value={l.unit_price} onChange={(e) => set(i, "unit_price", e.target.value)} required data-testid={`line-${i}-price`} className="bg-white px-3 py-2 text-sm text-right tnum outline-none" />
          <button type="button" onClick={() => remove(i)} disabled={lines.length === 1} className="bg-white text-zinc-400 hover:text-[#D0021B] disabled:opacity-30 flex items-center justify-center" data-testid={`line-${i}-remove`}><Trash size={12} /></button>
        </div>
      ))}
    </div>
  );
}
